import React from "react";

import { Stack, Typography } from "@mui/material";

interface Props {
  message: string;
  moveTo: string;
}

export const ToastContent: React.FC<Props> = ({ message, moveTo }) => {
  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ minWidth: 385, padding: "10px" }}>
      <Typography variant="body2">
        {message}
        <br />
        Associate To: {moveTo}
      </Typography>
    </Stack>
  );
};
